export type ReconnectTiming = {
    baseDelayMs: number;
    maxDelayMs: number;
    jitterRatio: number;
};

export const calculateReconnectDelayMs = (
    attempt: number,
    timing: ReconnectTiming,
    randomValue = Math.random()
): number => {
    const normalizedAttempt = Math.max(0, Math.trunc(attempt));
    const baseDelayMs = Math.max(0, timing.baseDelayMs);
    const maxDelayMs = Math.max(baseDelayMs, timing.maxDelayMs);
    const jitterRatio = Math.max(0, Math.min(1, timing.jitterRatio));
    const exponentialDelayMs = Math.min(maxDelayMs, baseDelayMs * 2 ** normalizedAttempt);
    const normalizedRandom = Math.max(0, Math.min(1, randomValue));
    const jitterMultiplier = 1 - jitterRatio + normalizedRandom * jitterRatio * 2;

    return Math.max(0, Math.round(Math.min(maxDelayMs, exponentialDelayMs * jitterMultiplier)));
};

export const isConnectionHeartbeatTimedOut = (
    lastMessageAt: number,
    now: number,
    timeoutMs: number
): boolean => now - lastMessageAt >= Math.max(1, timeoutMs);
